import Datetime from 'react-datetime'
import moment from 'moment'
import type { InstallationRigFooterState } from '../../types'

interface Props {
  isView: boolean
  rigFooter: InstallationRigFooterState
  updateRigFooter: (patch: Partial<InstallationRigFooterState>) => void
}

const InstallationRigFooterSection: React.FC<Props> = ({
  isView,
  rigFooter,
  updateRigFooter,
}) => {
  return (
    <div className='col-12'>
      <div className='card'>
        <div className='card-header'>
          <div className='card-title fw-bold'>
            สำหรับเจ้าหน้าที่ปั้นจั่น / ใช้ปั้นจั่นของ
          </div>
        </div>
        <div className='card-body'>
          <div className='row gy-4'>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>ใช้ปั้นจั่นของ</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={rigFooter.rigOwner}
                disabled={isView}
                onChange={e => updateRigFooter({ rigOwner: e.target.value })}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>จำนวน</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={rigFooter.quantity}
                disabled={isView}
                onChange={e => updateRigFooter({ quantity: e.target.value })}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>น้ำหนักตุ้ม (ตัน)</label>
              <input
                type='text'
                inputMode='decimal'
                className='form-control form-control-sm'
                value={rigFooter.hammerWeightTons}
                disabled={isView}
                onChange={e => updateRigFooter({ hammerWeightTons: e.target.value })}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>ผู้จัดปั้นจั่น</label>
              <input
                type='text'
                className='form-control form-control-sm'
                value={rigFooter.rigOrganizer}
                disabled={isView}
                onChange={e => updateRigFooter({ rigOrganizer: e.target.value })}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>ความสูงของปั้นจั่น (ม.)</label>
              <input
                type='text'
                inputMode='decimal'
                className='form-control form-control-sm'
                value={rigFooter.rigHeightMeters}
                disabled={isView}
                onChange={e => updateRigFooter({ rigHeightMeters: e.target.value })}
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>ให้ปั้นจั่นเข้าวันที่</label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                value={rigFooter.rigArrivalDate ?? undefined}
                onChange={(val: any) => {
                  if (moment.isMoment(val) || val instanceof Date) {
                    updateRigFooter({ rigArrivalDate: moment(val).toDate() })
                  }
                }}
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    className='form-control form-control-sm'
                    disabled={isView}
                  />
                )}
                closeOnClickOutside
              />
            </div>
            <div className='col-12 col-md-6 col-xl-4'>
              <label className='form-label fs-7 fw-bold mb-1'>วันที่</label>
              <Datetime
                locale='en'
                dateFormat='DD/MM/YYYY'
                timeFormat={false}
                value={rigFooter.date ?? undefined}
                onChange={(val: any) => {
                  if (moment.isMoment(val) || val instanceof Date) {
                    updateRigFooter({ date: moment(val).toDate() })
                  }
                }}
                renderInput={props => (
                  <input
                    {...props}
                    autoComplete='off'
                    className='form-control form-control-sm'
                    disabled={isView}
                  />
                )}
                closeOnClickOutside
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstallationRigFooterSection
